import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaHome, FaCalendarAlt, FaUserFriends, FaListUl } from "react-icons/fa";
import { useSalon } from "../../context/SalonContext";
import LogoutModal from "../logout/LogoutModal";
import "./Header.css";
import { toast } from "react-toastify";
import NotificationBell from "../notifications/NotificationBell";

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const navigate = useNavigate();

    const { customerName, logout, membershipCount, salonName } = useSalon();

    const closeMenu = () => setMenuOpen(false);

    const confirmLogout = () => {
        logout();
        setMenuOpen(false);
        setShowLogoutModal(false);
        toast.info("👋 You have logged out successfully");
        navigate("/login");
    };

    return (
        <>
            <nav className="topnav">
                <div className="topnav-left">
                    <div className="title">
                        {salonName ? salonName : "Salon Appointment Booking"}
                    </div>
                </div>

                {/* Hamburger icon */}
                <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </div>

                {/* Mobile Menu + Overlay */}
                {menuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}

                <div className={`topnav-right ${menuOpen ? "open" : ""}`}>
                    {customerName && (
                        <div className="nav-greeting mobile-greeting">
                            <div className="greeting-text">Hi, {customerName} 👋</div>
                        </div>
                    )}

                    <Link to="/home" className="nav-link" onClick={closeMenu}>
                        <FaHome className="nav-icon" /> Home
                    </Link>
                    <Link to="/booking" className="nav-link" onClick={closeMenu}>
                        <FaUserFriends className="nav-icon" /> {salonName ? salonName : "My Salon"}
                    </Link>
                    <Link to="/loyaltyWallet" className="nav-link" onClick={closeMenu}>
                        <FaCalendarAlt className="nav-icon" /> Loyalty
                    </Link>
                    <Link to="/viewBookings" className="nav-link" onClick={closeMenu}>
                        <FaCalendarAlt className="nav-icon" /> My Appointments
                    </Link>
                    <Link to="/membership-plans" className="nav-link" onClick={closeMenu}>
                        <FaListUl className="nav-icon" /> Membership Plans
                    </Link>
                    <Link to="/my-memberships" className="nav-link" onClick={closeMenu}>
                        <FaListUl className="nav-icon" /> My Memberships
                        {membershipCount > 0 && ` (${membershipCount})`}
                    </Link>

                    {/* ✅ Notifications only visible in mobile menu */}
                    <Link to="/notifications" className="nav-link" onClick={closeMenu}>
                        {/* <FaBell className="nav-icon" />  */}
                        <NotificationBell customerId={localStorage.getItem("CUSTOMER_ID")} />
                    </Link>


                    {/* ✅ Show Login if not logged in, Logout if logged in */}
                    {!customerName ? (
                        <Link to="/login" className="nav-link login-link" onClick={closeMenu}>
                            Login
                        </Link>
                    ) : (
                        <div>
                            <button
                                className="nav-link logout-link"
                                onClick={() => {
                                    closeMenu();
                                    setShowLogoutModal(true);
                                }}
                            >
                                Logout
                            </button>
                        </div>
                    )}
                    {/* Desktop greeting + logout */}
                    <div className="header-center">
                        {customerName && (
                            <div className="nav-greeting desktop-greeting">
                                {/* <NotificationBell customerId={localStorage.getItem("CUSTOMER_ID")} /> */}
                                <span className="greeting-text">Hi, {customerName} 👋</span>
                                <button
                                    className="logout-btn"
                                    onClick={() => setShowLogoutModal(true)}
                                >
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </nav>

            {/* Logout Modal */}
            <LogoutModal
                show={showLogoutModal}
                onClose={() => setShowLogoutModal(false)}
                onConfirm={confirmLogout}
            />
        </>
    );
}
